import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import { Button, Text, TitleText } from '@/ui';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goBackOrLogin = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate('/');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className={styles.notFoundContainer}>
      <TitleText type='h3' color='base-blue'>
        {t('Shared.404')}
      </TitleText>
      <Text size='s' weight='light-medium' color='base-blue'>
        {t('Shared.page_not_found')}
      </Text>
      <Button onClick={goBackOrLogin} variant='link' size='large'>
        {t('Shared.go_back')}
      </Button>
    </div>
  );
};

export default NotFound;
